// @ts-nocheck

import { useEffect, useMemo, useRef, useState } from 'react';

import usePrevious from './usePrevious';

const useDelayedPropVariation = (p: unknown) => {
  const [delayedProp, setDelayedProp] = useState(p);
  const propTimeoutIdRef = useRef();
  const prevProp = usePrevious(delayedProp);

  useEffect(() => {
    propTimeoutIdRef.current = setTimeout(() => {
      setDelayedProp(p);
    }, 1000);
  }, [p]);

  useEffect(() => {
    return () => {
      if (!propTimeoutIdRef.current) {
        clearTimeout(propTimeoutIdRef.current);
        propTimeoutIdRef.current = null;
      }
    };
  }, []);

  return useMemo(() => [delayedProp, prevProp], [delayedProp, prevProp]);
};

export default useDelayedPropVariation;
